<template>
	<div class="contact">
		<div v-for="(project, index) in projects" :key="index">
			{{ project.name }}
			<button @click="rmProject(index)">Remove</button>
		</div>

		<button @click="addProject">
			Add Project
		</button>

		{{ getProjectCount }}
	</div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';

export default {
	name: 'projects',
	data() {
		return {
			newProject: {
				name: 'a',
				build: 'b'
			}
		}
	},
	computed: {
		...mapState([
			'projects'
		]),
		...mapGetters([
			'getProjectCount'
		])
	},
	components: {

	},
	methods: {
		...mapMutations([
			'ADD_PROJECT'
		]),
		addProject: function() {
			this.ADD_PROJECT(this.newProject);
		},



		...mapActions([
			'removeProject'
		]),
		rmProject: function(payload) {
			this.removeProject(payload);
		}
	}
}
</script>
